import React from "react";

const HelpIcon = ({fill, stroke}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="25.525"
      // height="25.525"
      width="3rem"
      height="3rem"
      viewBox="0 0 25.525 25.525"
      style={{ fill: fill, stroke: stroke }}

    >
      <g id="help_ic" transform="translate(-169.304 -169.289)">
        <path
          id="Path_1882"
          data-name="Path 1882"
          d="M194.255,182.05a12.128,12.128,0,1,1-.14-1.864,12.014,12.014,0,0,1,.14,1.864.286.286,0,0,0,.571,0,12.692,12.692,0,0,0-2.35-7.38,13.014,13.014,0,0,0-2.667-2.761,12.751,12.751,0,0,0-17.573,2,12.968,12.968,0,0,0-1.993,3.329,12.718,12.718,0,0,0-.9,3.829,12.873,12.873,0,0,0,.323,4.006,12.8,12.8,0,0,0,7.123,8.6,12.793,12.793,0,0,0,7.849.882,12.625,12.625,0,0,0,3.635-1.348,12.808,12.808,0,0,0,5.222-5.465,12.684,12.684,0,0,0,1.182-3.714,13.082,13.082,0,0,0,.154-1.976.287.287,0,0,0-.574,0Z"
          transform="translate(0 0)"
        />
        <path
          id="Path_1883"
          data-name="Path 1883"
          d="M371.38,475.911v.514a.286.286,0,0,0,.571,0v-.514a.286.286,0,0,0-.571,0Z"
          transform="translate(-189.601 -287.425)"
        />
        <path
          id="Path_1884"
          data-name="Path 1884"
          d="M303.969,263.36a3.91,3.91,0,1,1,5.879,3.383,9.262,9.262,0,0,0-1.054.582,3.038,3.038,0,0,0-1.182,2.1,13.081,13.081,0,0,0-.014,1.379v.154a.286.286,0,0,0,.571,0v-1.222a2.461,2.461,0,0,1,.894-1.893,7.091,7.091,0,0,1,1.056-.591,4.482,4.482,0,1,0-6.675-4.514,4.633,4.633,0,0,0-.046.628.285.285,0,0,0,.571,0Z"
          transform="translate(-125.817 -84.065)"
        />
      </g>
    </svg>
  );
};

export default HelpIcon;
